import React from 'react';
import ContactUs from '../../containers/ContactUs/ContactUs';

export class ContactUsPage extends React.Component {
  render() {
    return (
      <ContactUs />
    );
  }
}